/**
 * Created by pajicv on 9/28/18.
 */

import React from 'react';
import TitleDescriptionBox from '../common/TitleDescriptionBox';
import { withStyles, Button, Typography, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    innerContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%'
    },
    innerContainer2: {
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        padding: 25,
    },
    addButton: {
        marginTop: 10,
        width: 225,
        height: 20
    }
});

class ProjectTargetGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            targetGroups: {},
            selectedTargetGroupId: null,
            name: '',
            description: ''
        }
    }

    componentDidMount() {
        if (this.props.targetGroups) {
            this.setState({
                targetGroups: this.props.targetGroups
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.targetGroups !== this.props.targetGroups) {
            this.setState({ targetGroups: this.props.targetGroups })
        }
    }


    handleTextFieldChange = (propertyName, index, field, value) => {
        this.setState((state) => {
            const property = state[propertyName];
            property[index][field] = value;
            return { ...state, property };
        });
    };

    handleNameChange = (e) => this.setState({ name: e.target.value});

    handleDescriptionChange = (e) => this.setState({ description: e.target.value});

    handleSelectTagretGroup = (targetGroupId) => {
        this.setState(state => ({
            selectedTargetGroupId: targetGroupId,
            name: state.targetGroups[targetGroupId].name,
            description: state.targetGroups[targetGroupId].description,
        }));
    };

    handleSaveTargetGroup = () => {
        const { name, description, selectedTargetGroupId } = this.state;
        const { onSaveTargetGroup } = this.props;
        onSaveTargetGroup(selectedTargetGroupId, name, description);
        this.setState({ name: '', description: '', selectedTargetGroupId: null});
    };

    render() {

        const { classes, onAddTargetGroup, onDeleteTargetGroup, onTargetGroupNameBlur, onTargetGroupDescriptionBlur } = this.props;

        const { targetGroups, name, description } = this.state;

        const renderedTargetGroups = Object.keys(targetGroups || {}).map((targetGroupId) => {
            const { name, description } = targetGroups[targetGroupId];
            return <TitleDescriptionBox
                key={targetGroupId}
                name={name}
                description={description}
                onNameChange={(e) => this.handleTextFieldChange('targetGroups', targetGroupId, 'name', e.target.value)}
                onDescriptionChange={(e) => this.handleTextFieldChange('targetGroups', targetGroupId, 'description', e.target.value)}
                onNameBlur={(e) => onTargetGroupNameBlur(targetGroupId, e.target.value)}
                onDescriptionBlur={(e) => onTargetGroupDescriptionBlur(targetGroupId, e.target.value)}
                onDeleteClick={() => onDeleteTargetGroup(targetGroupId)}
                onClick={() => this.handleSelectTagretGroup(targetGroupId)}
            />
        });

        return (
            <div className={classes.container}>
                <div className={classes.innerContainer}>
                    <div className={classes.innerContainer2}>
                        <div style={{width: 400, textAlign: 'left'}}>
                            <Typography variant="title">Neue Zielgruppe definieren</Typography>
                        </div>
                            <TextField
                                style={{width: 400}}
                                label="Name"
                                margin="normal"
                                value={name}
                                onChange={this.handleNameChange}
                            />
                            <TextField
                                style={{width: 400}}
                                label="Beschreibung"
                                multiline
                                rows="4"
                                margin="normal"
                                value={description}
                                onChange={this.handleDescriptionChange}
                            />
                        <div style={{width: 400, textAlign: 'right'}}>
                            <Button
                                className={classes.addButton}
                                color="primary"
                                variant="contained"
                                aria-label="Add Target Group"
                                onClick={this.handleSaveTargetGroup}
                            >
                                Zielgruppe hinzufügen
                            </Button>
                        </div>
                    </div>
                    <div className={classes.innerContainer2}>
                        {renderedTargetGroups}
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(ProjectTargetGroups);



// WEBPACK FOOTER //
// ./src/components/ProjectSetup/ProjectTargetGroups.js